import { Button, CircularProgress, Grid } from '@material-ui/core';
import { BackIcon } from '@room-match/shared-ui-components';
import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useHistory, useParams } from 'react-router-dom';
import { ROUTES } from 'shared/constants/ROUTES';
import { RepresentationType } from 'shared/enums/RepresentationType';
import { IAddress } from 'shared/interfaces/IAddress';
import { IGeneralSection } from 'shared/interfaces/IGeneral';
import { ICreateGuardianPayload, ICreateTalentPayload } from 'shared/interfaces/ITalent';
import { IUser } from 'shared/interfaces/IUser';
import { IAgency } from 'shared/interfaces/utils/IAgency';
import { countryStateApiService } from 'shared/services/countryStateApiService';
import { locationService } from 'shared/services/locationService';
import { profileService } from 'shared/services/profileService';
import { talentService } from 'shared/services/talentService';
import { uploadService } from 'shared/services/uploadService';
import { getCountry } from 'shared/utils/countryStateMapper';
import { ls } from 'shared/utils/ls';
import { useDebounce } from 'use-debounce';
import { captureMessage } from '../../../lib/sentry';
import { ProfileImageAdult } from '../AdultForm';
import { useStyles } from '../RegistrationForm.styles';
import { AddMembers } from './AddMembers';
import { AddNewMember } from './AddNewMember';
import { GuardianContactInformation } from './GuardianContactInformation';
import { useMinorForm } from './useMinorForm';

const {
  createProfile,
  setSelectProfileMedia,
  setProfilePrimaryImage,
  getProfileMatch,
  createMultipleProfiles,
  claimGhostedProfile,
} = profileService();
const { updateMe, createGuardian, createTalent, getTalentMembers, updateTalent } = talentService();
const { uploadMedia } = uploadService();
const { getCountries } = countryStateApiService();
const { createLocation } = locationService();
interface Props {
  showError: (header: string, message: string, button_text: string) => void;
}

const MinorForm: React.FC<Props> = ({ showError }) => {
  const [smsNotif, setSmsNotif] = useState<boolean>(true);
  const { mutateAsync: patchTalent } = updateTalent();
  const { mutateAsync: createLocAsync } = createLocation();
  const { mutate, isLoading: guardianCreating } = createGuardian();
  const { mutateAsync } = updateMe();
  const { mutateAsync: mutateAsyncUploadMedia } = uploadMedia();
  const { mutateAsync: claimAsync, isLoading: claimLoading } = claimGhostedProfile();
  const { mutateAsync: mutateAsyncCreateMulitipleProfile } = createMultipleProfiles();
  const { mutate: createTalentMutate } = createTalent();
  const { data: countriesData } = getCountries();
  const { body, footer, buttonCls, backIconButton } = useStyles();
  const { getLS, setLS, removeLS } = ls();
  const [val, setVal] = useState<number[] | null>([5, 7]);
  const user: IUser = JSON.parse(getLS('user') || '{}');
  const [selectedLocation, setSelectedLocation] = useState<IAddress | null>(null);
  const { resetToken, profileId, name, id, stageName, stageFirstName, stageLastName, agencyCountry } = JSON.parse(
    getLS('agency') || '{}',
  );
  const projectId = getLS('projectId');

  const [generalInfo, setgeneralInfo] = useState<IGeneralSection>({
    ethnic_appearance_primary: '',
    ethnic_appearance_secondary: '',
    ethnic_appearance_other: '',
    hair_colour: '',
    eye_colour: '',
    hair_length: '',
    tattoo: [],
    piercings: [],
    facial_hair: [],
    physical_attributes: [],
    twin_triplet: [],
  });

  const {
    data: membersData,
    isLoading: fetchingMember,
    refetch: refecthMembers,
  } = getTalentMembers('', getLS('auth_token'));
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  // prettier-ignore
  const [uploadedImg, setUploadedImg] = useState<{
    name: string;
    type: string;
    size: string;
    file: Blob | undefined;
    imageAttr: { width: number; height: number };
  } | null>(null);

  const [debounceFirst] = useDebounce(firstName, 500);
  const [debounceLast] = useDebounce(lastName, 500);

  const { data: profileMatchData } = getProfileMatch(true, debounceFirst, debounceLast, projectId);

  const [guardianInfo, setguardianInfo] = useState<ICreateGuardianPayload>({
    first_name: '',
    last_name: '',
    email: user.attributes?.email,
    contact_no: '',
    country_code: 'au',
    completed_primary_details: false,
  });

  const { step } = useParams() as { step: string };
  const history = useHistory();
  const [isMemberMinor, setisMemberMinor] = useState(true);
  const [isForGuardian, setisForGuardian] = useState(false);
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);
  const [representatives, setRepresentatives] = useState<
    {
      id: string;
      type: string;
      attributes: IAgency;
    }[]
  >([]);

  const handleSubmit = async (values: ICreateTalentPayload) => {
    console.log('values', values);
  };

  const { memberForm } = useMinorForm({
    onSubmit: handleSubmit,
  });

  const navigateToAddingMember = () => {
    history.push(ROUTES.MINOR_ADD_MEMBER);
  };

  const createGuardianAccount = async () => {
    // captureMessage({
    //   message: 'user is creating a guardian account',
    //   data: guardianInfo,
    // });
    const data = {
      ...guardianInfo,
      completed_primary_details: true,
    };

    await mutate(data, {
      onSuccess: async (res) => {
        await mutateAsync({
          other_phone_numbers: [
            {
              type: 'primary',
              country_code: data.country_code,
              number: data.contact_no,
            },
          ],
          preferences: {
            notification: {
              sms: smsNotif,
            },
          },
        });
        await refecthMembers();
        // captureMessage({
        //   message: 'user successfully created a guardian account',
        //   data: res.data,
        // });
        setLS('user', JSON.stringify(res.data));
        setLS('is_completed_primary_details', true);
        if (stageFirstName && stageFirstName !== '') {
          memberForm.setValues({
            ...memberForm.values,
            stage_first_name: stageFirstName,
            stage_last_name: stageLastName,
            first_name: stageFirstName,
            last_name: stageLastName,
          });
          setLS('hide_guardian', true);
          setTimeout(() => {
            history.push(ROUTES.MINOR_MEMBER_INFO);
          }, 100);
        } else {
          navigateToAddingMember();
        }
      },
    });
  };

  const memberValidation = () => {
    if (memberForm.values.country_code?.toLowerCase() === 'us') return memberForm.values.unions?.length === 0;
    if (!generalInfo.ethnic_appearance_primary) return true;
    if (!selectedLocation) return true;
    const divisionSupplied = representatives.some((r) => {
      if (r.attributes.divisions?.length > 0) {
        return r.attributes.selected_divisions ? r.attributes.selected_divisions?.length === 0 : true;
      }
      return false;
    });
    const { first_name, last_name, birth_date, email, stage_first_name, gender, contact_no } = memberForm.values;

    // Added a regular expression to check for temporary email addresses
    const tempEmailPattern = /@tempmail\.com$/;

    // Check if the email address is a temporary one and exclude it
    if (email && tempEmailPattern.test(email)) {
      return true; // Return true for temporary emails
    }
    if (memberForm.values.representation_type !== RepresentationType.FREELANCE && !representatives.length && !name) {
      return true;
    }

    if (isMemberMinor) {
      if (memberForm.values.managed_by_minor) {
        //minor checked
        if (first_name && last_name && birth_date && stage_first_name && gender && !divisionSupplied) {
          return false;
        }
      } else {
        //minor unchecked
        if (first_name && last_name && birth_date && stage_first_name && gender && !divisionSupplied) {
          return false;
        }
      }
    } else {
      if (isForGuardian) {
        //create profile for guadian
        if (first_name && stage_first_name && birth_date && gender && !divisionSupplied) {
          return false;
        }
      } else {
        //create adult account
        if (first_name && stage_first_name && birth_date && gender && !divisionSupplied && email && contact_no) {
          return false;
        }
      }
    }

    return true;
  };

  const backToAdding = () => {
    // captureMessage('user successfully added a member');
    setIsLoading(false);
    setRepresentatives([]);
    queryClient.removeQueries('talent/members');
    queryClient.invalidateQueries();
    memberForm.resetForm();
    history.push(ROUTES.MINOR_ADD_MEMBER);
  };

  const addRepresentatives = async (medium_id: string) => {
    // captureMessage({
    //   message: 'user is adding representatives',
    //   data: representatives,
    // });
    if (profileMatchData?.data.length) {
      await claimAsync(
        medium_id
          ? { profileId: profileMatchData.data.map((p) => p.profile_id), medium_id }
          : { profileId: profileMatchData.data.map((p) => p.profile_id) },
      );
    }

    if (representatives.length || name) {
      const profilesArr: any = [];

      //filter representatives that has division if profileMatchData is not empty
      const filteredRepresentatives = representatives.filter((r) => {
        if (profileMatchData?.data.length) {
          return (
            r.attributes.divisions?.length &&
            r.attributes.selected_divisions?.length > 0 &&
            r.attributes.selected_divisions[0] !== 'any'
          );
        }
        return true;
      });
      filteredRepresentatives.map((r) => {
        // profilesArr.push({ agency_id: r.id as string, representation_type: 'Agency Representation' });
        profilesArr.push({
          agency_id: r.id as string,
          representation_type: 'Agency Representation',
          ...(r.attributes.divisions.length > 0 &&
            r.attributes.selected_divisions[0] !== 'any' && {
              division_ids: r.attributes.selected_divisions,
            }),
        });
      });

      if (profilesArr.length === 0) {
        // captureMessage(`user has no representatives, creating profile with representation type Non-Represented`);
        return backToAdding();
      }
      // captureMessage({
      //   message: 'asd',
      //   data: { profiles: [...profilesArr], medium_id },
      // });
      mutateAsyncCreateMulitipleProfile(
        { profiles: [...profilesArr], medium_id },
        {
          onSuccess: () => backToAdding(),
          onError: (error: any) => {
            captureMessage({
              message: 'user failed to add representatives',
              data: error,
              level: 'error',
            });
            setIsLoading(false);
            showError(
              'Registration Failed',
              error?.response?.data?.errors?.base[0] || 'Failed to process request',
              'OK',
            );
          },
        },
      );
    } else {
      mutateAsyncCreateMulitipleProfile(
        {
          profiles: [
            {
              representation_type: 'Non-Represented',
            },
          ],
          medium_id,
        },
        { onSuccess: () => backToAdding() },
      );
    }
  };

  const createGuardianProfile = async (medium_id: string) => {
    const memberVal = { ...memberForm.values };
    delete memberVal.email;
    // captureMessage({
    //   message: '23123123',
    //   data: memberVal,
    // });
    if (selectedLocation)
      await createLocAsync({
        ...selectedLocation?.attributes,
      });
    await patchTalent({
      general: generalInfo,
    });
    await mutateAsync(
      {
        ...memberVal,
        medium_id,
        completed_primary_details: true,
        country_code: (memberVal.other_phone_numbers || [])[0].country_code,
        country: getCountry(countriesData, (memberVal.other_phone_numbers || [])[0].country_code.toUpperCase() || 'AU'),
        ...(val ? { age_range_from: val[0], age_range_to: val[1] } : {}),
      },
      {
        onSuccess: async (data) => {
          setLS('user', JSON.stringify(data.data));
          addRepresentatives(medium_id);
        },
        onError(error: any, variables, context) {
          captureMessage({
            message: 'user failed to create a guardian profile',
            data: error,
            level: 'error',
          });
          setIsLoading(false);
          const errorMessage = error.response.data.errors.base[0];
          setTimeout(() => {
            showError('Registration Failed', `${errorMessage}`, 'OK');
          }, 100);
        },
      },
    );
  };

  const addGuardianTalent = (medium_id: string) => {
    const guardianCountryCode = user.attributes.country_code || 'AU';

    const talentInfo = {
      ...memberForm.values,
      medium_id,
      general: generalInfo,
      other_phone_numbers: [
        {
          country_code: memberForm.values.country_code || guardianCountryCode,
          number: memberForm.values.contact_no || '',
          type: 'primary',
        },
        {
          country_code: memberForm.values.country_code || guardianCountryCode,
          number: '',
          type: 'secondary',
        },
        {
          country_code: memberForm.values.country_code || guardianCountryCode,
          number: '',
          type: 'other',
        },
        {
          country_code: memberForm.values.country_code || guardianCountryCode,
          number: '',
          type: 'other',
        },
      ],
      ...(selectedLocation?.attributes && {
        city_suburb: selectedLocation?.attributes.city_suburb,
        country_code: selectedLocation?.attributes.country_code,
        state_code: selectedLocation?.attributes.state_code,
        zip_code: selectedLocation?.attributes.zip_code,
      }),
      ...(val ? { age_range_from: val[0], age_range_to: val[1] } : {}),
      country: getCountry(countriesData, (memberForm.values.country_code || guardianCountryCode).toUpperCase() || 'AU'),
      ...(profileMatchData && profileMatchData?.data.length > 0 && { is_claiming: true }),
      ...(memberForm.values.managed_by_minor ? { email: memberForm.values.email } : { email: '' }),
      ...(representatives.length > 0 && {
        agency_ids: representatives.map((r) => r.id),
        representation_type: RepresentationType.AGENCY_REPRESENTATION,
        agency_divisions: representatives
          .filter((f) => f.attributes?.selected_divisions && f.attributes?.selected_divisions[0] !== 'any')
          .map((r) => ({
            agency_id: r.id,
            division_ids: r.attributes.selected_divisions,
          })),
      }),
    };

    const cleanTalent = Object.entries({
      ...talentInfo,
      completed_primary_details: true,
    }).reduce((acc: any, [key, value]: any) => {
      // Retain valid values, exclude null, undefined, and empty strings
      if (value !== undefined && value !== null && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {});

    // captureMessage({
    //   message: 'user is adding a talent',
    //   data: cleanTalent,
    // });
    // console.log('filter mo this', { cleanTalent });
    createTalentMutate(cleanTalent, {
      onSuccess: async (user) => {
        // captureMessage({
        //   message: 'user successfully added a talent',
        //   data: user,
        // });
        if (profileMatchData?.data.length) {
          // captureMessage({
          //   message: 'user is claiming a ghosted profile',
          //   data: profileMatchData.data,
          // });
          await claimAsync(
            { profileId: profileMatchData.data.map((p) => p.profile_id), medium_id, user_id: user.data.id },
            {
              onSuccess: () => {
                backToAdding();
              },
            },
          );
        } else if (profileId && profileId !== '' && stageName === user.data.attributes.stage_name) {
          // captureMessage({
          //   message: 'user is claiming an imported agency profile',
          //   data: { profileId },
          // });
          setLS('impersonate_id', user.data.id);
          removeLS('hide_guardian');
          await claimAsync(
            {
              profileId: [profileId],
              medium_id,
              user_id: user.data.id,
              is_guardian: true,
            },

            {
              onSuccess: () => {
                backToAdding();
              },
            },
          );
        } else {
          backToAdding();
        }
      },
      onError: (err: any) => {
        setIsLoading(false);
        captureMessage({
          message: 'user failed to add a talent',
          data: err,
          level: 'error',
        });
        if (err?.response?.data?.errors?.email && err?.response?.data?.errors?.email[0] === 'has already been taken') {
          memberForm.setErrors({ email: 'Email has already been taken' });
          showError('Registration Failed', `Email has already been taken`, 'OK');
        } else {
          if (err?.response?.data?.errors?.stage_name) {
            showError('Registration Failed', `Stage name has already been taken`, 'OK');
          } else {
            const errorMessage = err?.response?.data?.errors?.base
              ? err?.response?.data?.errors?.base[0]
              : 'Failed to process request';
            showError('Registration Failed', `${errorMessage}`, 'OK');
          }
        }
      },
    });
  };

  const createGuardianTalent = async (id?: string) => {
    setIsLoading(true);
    const medium_id = id || memberForm.values.medium_id || '';

    if (isForGuardian) {
      createGuardianProfile(medium_id);
    } else {
      addGuardianTalent(medium_id);
    }
  };
  const handleUploadImg = async (
    name: string,
    type: string,
    size: string,
    file?: Blob,
    imageAttr?: { width: number; height: number },
  ) => {
    if (file && imageAttr) {
      setUploadedImg({ name, type, size, file, imageAttr });
    }
  };

  const handleUploadAndProceed = async () => {
    if (uploadedImg) {
      if (uploadedImg.file) {
        setIsLoading(true);
        const formData = new FormData();
        formData.append('attachment', uploadedImg.file);
        formData.append('file_name', uploadedImg.name);
        formData.append('file_width', uploadedImg.imageAttr.width.toString());
        formData.append('file_height', uploadedImg.imageAttr.height.toString());
        formData.append('file_size', uploadedImg.size);
        formData.append('file_type', uploadedImg.type);
        formData.append('media_bin', 'true');
        const object: any = {};
        formData.forEach((value, key) => (object[key] = value));
        // captureMessage({
        //   message: 'user uploaded the following image',
        //   data: object,
        // });
        mutateAsyncUploadMedia(
          { formData },
          {
            onSuccess: async (data) => {
              memberForm.setValues({ ...memberForm.values, medium_id: data.data.id });
              createGuardianTalent(data.data.id);
            },
            onError(error: any) {
              captureMessage({
                message: 'user failed to upload the following image',
                data: error,
                level: 'error',
              });
              const errorMessage = error?.response?.data?.errors?.base[0];
              showError(
                'Image Upload Failed',
                errorMessage
                  ? `${errorMessage}\n\n Please choose another image and try again.`
                  : 'Please choose another image and try again.',
                'OK',
              );
              setIsLoading(false);
            },
          },
        );
      }
    }
  };

  const buttonValidation = () => {
    switch (step) {
      case 'guardian_info':
        return (
          !guardianInfo.first_name || !guardianInfo.last_name || guardianInfo.contact_no.length < 10 || guardianCreating
        );
      case 'add_member':
        return membersData?.data.talents.length === 0 || fetchingMember;
      case 'member_info':
        return memberValidation();
      case 'profile_image':
        return !uploadedImg;
      default:
        return false;
    }
  };
  const buttonFunction = () => {
    switch (step) {
      case 'guardian_info':
        return createGuardianAccount();
      case 'add_member':
        return history.push(ROUTES.REGISTRATION + '/complete');
      case 'member_info':
        return memberForm.values.medium_id ? createGuardianTalent() : history.push(ROUTES.MINOR_PROFILE_IMAGE);
      case 'profile_image':
        return handleUploadAndProceed();
      default:
        return () => {};
    }
  };

  const backButtonFunction = () => {
    switch (step) {
      case 'guardian_info':
        return history.push(ROUTES.REGISTRATION);
      case 'member_info':
        return history.push(ROUTES.MINOR_ADD_MEMBER);
      case 'profile_image':
        return history.push(ROUTES.MINOR_MEMBER_INFO);
      default:
        return () => {};
    }
  };

  const renderComponent = () => {
    switch (step) {
      case 'guardian_info':
        return (
          <GuardianContactInformation
            guardianInfo={guardianInfo}
            setGuardianInfo={setguardianInfo}
            smsNotif={smsNotif}
            setSmsNotif={setSmsNotif}
          />
        );
      case 'add_member':
        return <AddMembers members={membersData?.data.talents} />;
      case 'member_info':
        return (
          <AddNewMember
            selectedLocation={selectedLocation}
            setSelectedLocation={setSelectedLocation}
            profileMatch={profileMatchData}
            setFirstName={setFirstName}
            setLastName={setLastName}
            user={user}
            disableProfile={!!membersData?.data.talents.filter((f) => f.id === user.id).length}
            isForGuardian={setisForGuardian}
            isMemberMinor={setisMemberMinor}
            form={memberForm}
            setRepresentatives={setRepresentatives}
            representatives={representatives}
            val={val}
            setVal={setVal}
            generalInfo={generalInfo}
            setgeneralInfo={setgeneralInfo}
            guardianCountryCode={guardianInfo.country_code}
          />
        );
      case 'profile_image':
        return (
          <Grid item className={body}>
            <ProfileImageAdult onFileSelected={handleUploadImg} />
          </Grid>
        );
      default:
        return <div>Default</div>;
    }
  };

  // useEffect(() => {
  //   captureMessage('user landed on minor registration page');
  // }, []);

  return (
    <Grid item className={body}>
      {renderComponent()}
      <Grid item className={footer}>
        {step !== 'add_member' ? (
          <Button data-cy="back-button" className={backIconButton} onClick={backButtonFunction}>
            <BackIcon htmlColor="lightgrey" />
          </Button>
        ) : (
          <React.Fragment />
        )}
        <Button
          style={{ maxWidth: 340 }}
          color="primary"
          variant="contained"
          disableElevation
          fullWidth
          className={buttonCls}
          onClick={buttonFunction}
          disabled={buttonValidation() || isLoading}
        >
          {isLoading || guardianCreating || fetchingMember ? <CircularProgress size={25} /> : 'Continue'}
        </Button>
      </Grid>
    </Grid>
  );
};

export default MinorForm;
